export default __webpack_public_path__ + "static/BgImg06-6a2f1d16664c47febae2d7d0f49cbe7d.webp";